
import axios from "axios";
import { IMedia } from "../entities/IMedia";
import Axios from "./Axios";
import { get } from "./HttpApi";
import ENDPOINTS from "./endpoints";
import { unwrapList } from "./apiUtils";

const getAll = async () : Promise<Array<IMedia>> => {

      return await get(ENDPOINTS.media.all).then(res => {
          const data = res;
          return data;
        });

  };

  async function getAllMedias() {

    return new Promise((resolve) =>  {
      setTimeout(() => resolve(get(ENDPOINTS.media.create)), 200);
    });
  }

  const getMedias = () =>{
    return Axios.get<Array<IMedia>>(ENDPOINTS.media.all) ;
  }

  const createMedia = (data: IMedia)=> {
    return Axios.post<IMedia>(ENDPOINTS.media.createBulk, data);
  }

  const getMediaById = (id: number) => {
    return Axios.get<IMedia>(ENDPOINTS.media.byId(id));
  };

  const createMedias = (data: IMedia[])=> {
    return Axios.post<Array<IMedia>>(ENDPOINTS.media.create, data);
  }

  const uploadSingle = (
    file: File,
    entityId?: number,
    onUploadProgress?: any
  ): Promise<any> => {
    const formData = new FormData();
    const metadata = {
      filename: file.name,
      size: file.size,
      mediaType: file.type,
      entityId: entityId ?? null,
    };
    formData.append("data", JSON.stringify(metadata));
    formData.append("file", file);
    return Axios.post(ENDPOINTS.media.upload, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
  };

  const uploadMultiple = (
    files: File[],
    entityId?: number,
    onUploadProgress?: any
  ): Promise<any> => {
    const formData = new FormData();
    const metadataList = files.map((file) => ({
      filename: file.name,
      size: file.size,
      mediaType: file.type,
      entityId: entityId ?? null,
    }));
    formData.append("data", JSON.stringify(metadataList));
    files.forEach((file) => formData.append("files", file));
    return Axios.post(ENDPOINTS.media.uploadMultiple, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
  };

  const upload = (file: File, productId: number, onUploadProgress: any):
    Promise<Array<IMedia>> => {
    let formData = new FormData();
    formData.append("id", productId.toString());
    formData.append("files", file);
    formData.append("variantType", "")
    console.log('----------file-----------');
    return Axios.post(ENDPOINTS.media.uploadMultipleFiles, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  };

  const uploadFile = (file: File, productId: number):
    Promise<IMedia> => {
    let formData = new FormData();
    formData.append("id", productId.toString());
    formData.append("files", file);
    formData.append("variantType", "")
    console.log('----------file-----------');
    return Axios.post(ENDPOINTS.media.uploadMultipleFiles, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
  };

  const getFiles = (productId: number) : Promise<any> => {
    return Axios.get(ENDPOINTS.media.productFiles(productId));
  };

  const sliderfiles = (productId: number) : Promise<any> => {
    return Axios.get(ENDPOINTS.media.sliderFiles(productId));
  };

  const getMediaByProduct = (productId: number | string) : Promise<Array<IMedia>> => {
    return Axios.get(ENDPOINTS.media.byProduct(productId)).then((res) =>
      unwrapList<IMedia>(res)
    );
  };

  const deleteMedia = (type: string, mediaId: number) : Promise<string> => {
    return Axios.delete(ENDPOINTS.media.deleteMedia(type, mediaId));
  }

  const updateSeq = (mediaId: number, seq: number) : Promise<IMedia> => {
    return Axios.put(ENDPOINTS.media.updateSeq(mediaId, seq));
  }
  const updateSeqByProductId = (prodId: number) : Promise<IMedia> => {
    return Axios.put(ENDPOINTS.media.updateSeqByProductId(prodId));
  }

  const MediaService = {
    getAll,
    get,
    createMedia,
    createMedias,
    upload,
    uploadSingle,
    uploadMultiple,
    getFiles,
    deleteMedia,
    updateSeqByProductId,
    updateSeq,
    sliderfiles,
    getMediaByProduct,
    uploadFile
  };

  export default MediaService;